import { Component, OnInit, OnDestroy } from '@angular/core';
import { HeaderData } from 'src/app/_models/header-data';
import { ReportsService } from 'src/app/_services/reports.service';
import { BehaviorSubject } from 'rxjs';
import { PageCriteria } from 'src/app/_models/page-criteria';
import { RESULTS_NOT_FOUND } from 'src/app/_common/product-config';
import { Router } from '@angular/router';
import { CommonService } from 'src/app/_services/common.service';
import { Modules, StatusCode } from 'src/app/_common/_enum/module.enum';

@Component({
  selector: 'app-pending-cancellation-report',
  templateUrl: './pending-cancellation-report.component.html',
  styleUrls: ['./pending-cancellation-report.component.scss']
})
export class PendingCancellationReportComponent implements OnInit, OnDestroy {

  //Create HeaderData object to show the Data on Blue Header.
  private headerData:HeaderData;

  private results = [];
  private _total$ = new BehaviorSubject<number>(0);
  private hasAccess:boolean = false;
  private loading: boolean = false;
  private criteria: PageCriteria;

  resultsNotFound = RESULTS_NOT_FOUND;

  //private killServicesOnDestroy = [];
  
  constructor(private router: Router, private reportsService: ReportsService, private commonService: CommonService) { }

  ngOnInit() {
    this.fetchPendingCancellations();
    /* Setting Headers Starts */
    this.headerData = new HeaderData();
    this.setHeaderData();
    /* Setting Headers Ended */
    this.criteria = new PageCriteria();
  }

  setHeaderData(){
    this.headerData.pageTitle = 'Pending Cancellations';
    this.reportsService.header = this.headerData;
  }

  get total$() { return this._total$.asObservable(); }

  fetchPendingCancellations(){
    this.loading = true;
    this.hasAccess = this.commonService.checkPermission(Modules.ReportBillingPCN);
    if(this.hasAccess){
      let pendingCancellationsSubscription = this.reportsService.fetchPendingCancellations().subscribe((policies:any)=>{
        this.loading = false;
        this.results = policies;
        this._total$.next(this.results.length);
      },
      error=>{
        this.loading = false;
        this.results = null;
        this.hasAccess = !(error.status == StatusCode.NoAccess);
      });

      this.reportsService.runningServices.push(pendingCancellationsSubscription);
    }else{
      this.loading = false;
    }
  }

  openDirectBill(result){
    let account = {
      "accountNumber": result.accountNumber,
      "accountName": result.insuredName, 
      "accountEndorsementsTab": null
    }
    this.reportsService.storeAccountData(account);
    this.router.navigateByUrl("accounts/"+result.accountNumber+"/directbill");
  }
  
  onPageChange(){
    window.scrollTo(0, 0);
  }

  ngOnDestroy() {
    this.reportsService.runningServices.forEach(subscription =>subscription.unsubscribe());
  }

}
